var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"section_banner"},[(_vm.gnbBanners.length > 0)?_c('BannerPanel',{attrs:{"data":_vm.gnbBanners[0]}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }